import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { fetchWithAuth } from '../utils/fetchWithAuth';
import { Info } from 'lucide-react';

const API = process.env.REACT_APP_API_BASE;

export default function SelectIndustry() {
  const [industries, setIndustries] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchWithAuth(`${API}/api/industries`)
      .then(res => res.json())
      .then(data => setIndustries(data.filter(i => i.isActive)))
      .catch(() => toast.error('Failed to load industries'))
      .finally(() => setLoading(false));

      
        document.title = "Select Your Industry – Ennoverse";
      
  }, []);

  const handleSelect = async (industryId) => {
    try {
      const res = await fetchWithAuth(`${API}/api/users/set-industry/${industryId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ industryId })
      });

      if (!res.ok) throw new Error('Failed to update industry');

      toast.success('Industry selected');
      navigate('/payment');
    } catch (err) {
      toast.error(err.message || 'Something went wrong');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-12 flex flex-col items-center">
      <img src="/ennoverse.png" alt="Ennoverse Logo" className="h-10 mb-4" />
      <div className="text-center max-w-2xl mb-10">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Select Your Industry</h1>
        <p className="text-gray-600 text-sm">
          This helps us personalize your dashboard and show you the most relevant AI tools for your field.
        </p>
      </div>

      {loading ? (
        <div className="text-center text-gray-600 mt-10">Loading industries...</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-6xl">
          {[
            ...industries.filter(i => i.displayName !== 'Other Industries'),
            ...industries.filter(i => i.displayName === 'Other Industries')
          ].map(ind => (
            <div
              key={ind._id}
              onClick={() => handleSelect(ind._id)}
              className="cursor-pointer bg-white rounded-2xl shadow-md p-6 border border-gray-200 hover:shadow-xl hover:border-primary transition-all group flex flex-col items-center text-center min-h-[240px]"
            >
              <div className="flex items-center justify-center text-primary mb-4">
                {ind.icon
                  ? React.createElement(require('lucide-react')[ind.icon], { size: 40 })
                  : <span className="text-3xl">🏷️</span>}
              </div>

              <h2 className="text-lg font-semibold text-gray-800">{ind.displayName}</h2>

              {ind.url && (
                <div className="mt-1">
                  <a
                    href={ind.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Learn more about this industry"
                    className="text-blue-500 hover:text-blue-700 text-sm inline-flex items-center gap-1"
                  >
                   More Info <Info className="w-4 h-4" />
                    
                  </a>
                </div>
              )}

              {ind.description && (
                <p className="text-sm text-gray-600 mt-2">{ind.description}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
